import { useState, useEffect } from 'react';
import close from "../../assets/images/close.png";
import { styled } from '@mui/material/styles';
import { Autocomplete, TextField, Snackbar, Alert } from '@mui/material';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import {
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Button,
  Form,
  Input,
  FormGroup,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Col,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../actions/user.actions';
import increase from '../../assets/images/increase.png';
import minus from '../../assets/images/minus.png';
import { useCurrentUser } from '../../hooks/useCurrentUser';

export default function AddProducts( {Tenure,Roi,IncludeBPI,DetectBroken,AddBrokenToFirstEmi,DaysConvention,Frequency,PfType,PfTypeValue,advance,FlateRate,productCategory,openDialog,setOpenDialog,onProductCreated} ){
  const decode = useCurrentUser();
  const user = null;
  const [load,setLoading]=useState(false)
  const [status, setStatus] = useState(productCategory ? productCategory : decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "Standard EMI" : "Select Category of Product");
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const handleSnackbarClose = () => setSnackbar(prev => ({ ...prev, open: false }));
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [formDropDownOpen, setFormDropDownOpen] = useState(false);
  const [disbursementMonth1DropDownOpen, setDisbursementMonth1DropdownOpen] = useState(false);
  const [disbursementMonth2DropDownOpen, setDisbursementMonth2DropdownOpen] = useState(false);
  const [disbursementMonth4DropDownOpen, setDisbursementMonth4DropdownOpen] = useState(false);
  const [frequency, setFrequency] = useState(Frequency?Frequency:"Monthly");
  const [daysConvention, setDaysConvention] = useState(360);
 

  const handleToggle = () => {
    setDropDownOpen(!dropDownOpen);
  };
  const handleFormToggle = () => {
    setFormDropDownOpen(!formDropDownOpen);
  };
  const handleDisbursementMonth1Toggle= () => {
    setDisbursementMonth1DropdownOpen(!disbursementMonth1DropDownOpen);
  };
  const handleDisbursementMonth2Toggle= () => {
    setDisbursementMonth2DropdownOpen(!disbursementMonth2DropDownOpen);
  };

  const handleDisbursementMonth4Toggle= () => {
    setDisbursementMonth4DropdownOpen(!disbursementMonth4DropDownOpen);
  };

  //form 
  const [prodTenure,setTenure]=useState(Tenure ?Tenure: null)
  const [fldgReturn,setFldgReturn]=useState("FLDG")
  const [advanceEMIValue,setAdvanceEMI]=useState(advance?advance:"Advance EMI")
  const [disbursementMonth1,setDisbursementMonth1]=useState("Month 1")
  const [disbursementMonth2,setDisbursementMonth2]=useState("Month 2")
  const [disbursementMonth3,setDisbursementMonth3]=useState("Month 3")
  const [disbursementMonth4,setDisbursementMonth4]=useState("Month 4")
  const tenureArray=["Dynamic",1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36]
  const disbursementMonth1Array=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36]
  const disbursementMonth2Array=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36]
  const disbursementMonth3Array=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36]
  const disbursementMonth4Array=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36]
  const fldgArray=[3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36]
  const advanceEMIArray=[0,1,2,3,4,5,6,7,8,9,10,11,12]
  const [DITChoice,setDitChoice]=useState(true)
  const [SITChoice,setSitChoice]=useState(true)
  const [interestChoice,setInterestChoice]=useState(true)
  const [fldg,setFldg]=useState(FlateRate?FlateRate:false)
  const [pfType,setPftype]=useState(null)
  const [limitAmt,setPfLimitAmount]=useState(null)
  const [gst,setGST]=useState(true)
  const [brokenPeriodInterest, setBrokenPeriodInterest] = useState(IncludeBPI !== undefined ? IncludeBPI : false);
  const [detectBroken,setDetectBroken]=useState(DetectBroken !== undefined ? DetectBroken : false)
  const [addBrokenToFirstEmi,setAddBrokenToFirstEmi]=useState(AddBrokenToFirstEmi !== undefined ? AddBrokenToFirstEmi : false)
  const [disburse,setDisbursement]=useState(false)
  const [disbursermentPercentage1,setDisbursementPercentage1]=useState(null)
  const [disbursermentPercentage2,setDisbursementPercentage2]=useState(null)
  const [disbursermentPercentage3,setDisbursementPercentage3]=useState(null)
  const [disbursermentPercentage4,setDisbursementPercentage4]=useState(null)
  const [addDisbursement,setAddDisbursement]=useState(false)
  const [addDisbursement2,setAddDisbursement2]=useState(false)
  const [addDisbursementNext,setAddDisbursementNext]=useState(true)
  const [tenureType,setTenureType] =useState(true)

  useEffect(() => {
    if (Tenure) {
      setTenure(Tenure);
    }
   if(Roi){
    setIR(Roi);
   }

   if(IncludeBPI !== undefined){
    setBrokenPeriodInterest(IncludeBPI );
   }
   if(DetectBroken !== undefined){
    setDetectBroken(DetectBroken );
   }
   if (AddBrokenToFirstEmi !== undefined) {
    setAddBrokenToFirstEmi(AddBrokenToFirstEmi);
  }
   if(Frequency){
    setFrequency(Frequency)
   }
   if(DaysConvention){
    setDaysConvention(DaysConvention)
   }

   if(PfType){
    setPftype(PfType)
   }

   if(PfTypeValue){
    setPfTypeValue(PfTypeValue)
   }

   if(advance){
    setAdvanceEMI(advance)
   }

   if(FlateRate){
    setFldg(FlateRate)
   }
   if(productCategory){
    setStatus(productCategory)
   }

   if (productCategory) {
    handleLoad(productCategory);
  } else if (decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361') {
    handleLoad({ target: { innerText: "Standard EMI" } });
  }

  }, [Tenure,Roi,IncludeBPI,DetectBroken,AddBrokenToFirstEmi,Frequency,DaysConvention,PfType,PfTypeValue,advance,FlateRate,productCategory]);


const [productCode,setProductCode]=useState(null)
  
const handleAddDisbursement=()=>{
    setAddDisbursement2(!addDisbursement2)
    setAddDisbursementNext(!addDisbursementNext)
    
  }

const handleAddDisbursement2=()=>{
  setAddDisbursementNext(!addDisbursementNext)
}

const [instituteList, setInstituteList] = useState([]);
const [startingPhrase,setStarterPhrase]=useState("Type Institute Name")
const [instituteCode,setInstituteCode]=useState(null)


const dispatch=useDispatch();

const instituteState=useSelector((state)=>state?.GETINSTITUTE?.res?.data?.data)
const getInsituteInfo=(text)=>{
  const urlGetInstitute=`/institute/info/name?name=${text}`;
    
  if(text.length>=4)
  {
   dispatch(userActions.getInstituteInfo(urlGetInstitute,user))
   setInstituteList(instituteState)
  }
  else{
    setInstituteList([]);
    setStarterPhrase("Type Institute Name")
  }
}

const handleLoad=(e)=>{

  const category = productCategory || (e?.target?.innerText);
    setDisbursement(false)
    setPftype(PfType?PfType:"Select")
    setSitChoice(true)
    setDitChoice(true)
    setInterestChoice(true)
    setFldg(FlateRate?FlateRate:false)
    setGST(true)
    setLoading(false)
    setStatus(category)
      if (category === "Hybrid") {
        setProductCode("HYD");
      } else if (category === "Standard EMI") {
        setProductCode("STD");
      } else if (category === "Subvention GST") {
        setProductCode("SVN");
      } else if (category === "Subvention Non GST") {
        setProductCode("SNN");
      } else if (category === "B2B") {
        setProductCode("BB");
      }
    setInstituteList([]);
    setInstituteCode(null);
    setTenure(Tenure || null);
    setIR(Roi || null);
    setFldgReturn("FLDG Return")
    setAdvanceEMI(advance?advance:"Advance EMI")
    setDisbursementMonth1("Month 1")
    setDisbursementMonth2("Month 2")
    setDisbursementMonth3("Month 3")
    setDisbursementMonth4("Month 4")
    setTimeout(() => {
    setLoading(true)
  }, 1000);
  }

//Creating Product API
const [instituteID,setInstituteID]=useState(null)
const [selectedInstitutes, setSelectedInstitutes] = useState([]); 
const [instituteIds, setInstituteIds] = useState([]); 
const [productName,setProductName]=useState(null)
const [studShare,setStudentShare]=useState(null)
const [instShare,setInstituteShare]=useState(null)
const [FLDGpercentage,setFldgPercentage]=useState(null)
const [pfTypeValue,setPfTypeValue]=useState(PfTypeValue?PfTypeValue:null)
const [otherCharges,setOtherCharges]=useState(null)
const [docChargesType,setDocChargesType]=useState("Flat")
const [docChargesValue,setDocChargesValue]=useState(null)
const [stampDutyValue,setStampDutyValue]=useState(null)
const [IRR,setIRR]=useState(null)
const [dir,setDIR]=useState(null)
const [sir,setSIR]=useState(null)
const [ir,setIR]=useState(null)
const loanTypeOptions = [
  { label: "Education Loan", code: "EL" },
  { label: "Personal Loan", code: "PL" },
  { label: "Business Loan", code: "BL" },
  { label: "Others", code: "OT" },
];

const [loanType, setLoanType] = useState(null); 
const [loanTypeCode, setLoanTypeCode] = useState("");


const handleInstituteDetails=(data)=>{
  // document.getElementById("instituteNameBox").value=data.brandName
  setInstituteCode(data?.code)
  setInstituteID(data?.id)
  setInstituteList(null)

}



//create Product
const createProductState=useSelector((state)=>state?.CREATEPRODUCT?.res?.data?.message)
 
const handleCreateProduct=()=>{
  if(IRR&&(pfTypeValue)&&(fldg?isNaN(fldgReturn)?false:true:true)&&(isNaN(advanceEMIValue)?false:true)){
    if(!productName && (decode?.clientId !== 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c')){
      setSnackbar({ open: true, message: 'Product Name Missing or Check Length', severity: 'error' })
  }else if(prodTenure === null || prodTenure === ''){
      setSnackbar({ open: true, message: 'Please select the Tenure', severity: 'error' })
  }
  else
  {

  
    const productData={
  
    name: (decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c') 
      ? `${autoProductCode}`
      : `${instituteCode}${productCode}${productName}`,
    tenure: prodTenure,
    instituteId: (decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c') ? instituteIds : [instituteID],
    facilityType: status==="Hybrid"?3:status==="Subvention GST"?1:status==="Subvention Non GST"?5:status==="BusinessToBusiness"?4:status==="Standard EMI"?2:0,
    irr: IRR * 0.01,
    discountedInterestPercentage: (getNormalizedProductCode(productCode)==="SV"||getNormalizedProductCode(productCode)==="SN")?ir*0.01:(getNormalizedProductCode(productCode)==="ST"||productCode==="BB")?0:(getNormalizedProductCode(productCode)==="HY")?dir*0.01:0,
    instituteShare:(getNormalizedProductCode(productCode)==="HY")?instShare*0.01:(getNormalizedProductCode(productCode)==="SV"||getNormalizedProductCode(productCode)==="SN")?100:(getNormalizedProductCode(productCode)==="ST")?0:0,
    studentShare:(getNormalizedProductCode(productCode)==="HY")?studShare*0.01:(getNormalizedProductCode(productCode)==="SV"||getNormalizedProductCode(productCode)==="SN")?0:(getNormalizedProductCode(productCode)==="ST")?100:0,
    discountedInterestType: DITChoice===true?2:1,
    standardInterestPercentage: (getNormalizedProductCode(productCode)==="SV"||getNormalizedProductCode(productCode)==="SN")?0:(getNormalizedProductCode(productCode)==="ST"||productCode==="BB")?ir*0.01:(getNormalizedProductCode(productCode)==="HY")?sir*0.01:0,
    standardInterestType: ((SITChoice && status==="Hybrid") || (interestChoice && status!=="Hybrid"))===true?2:1,
     processingfeeType: pfType==="Varied"?3:pfType==="Flat"?1:2,            
    limitAmount:pfType==="Varied"?limitAmt:0,                           
    processingfeeValue: parseFloat((pfType==="Flat" ? parseFloat(pfTypeValue) : parseFloat(pfTypeValue)*0.01).toFixed(4)),
    processingfeeValueGST: gst===true ? parseFloat((pfType==="Flat" ? parseFloat(pfTypeValue)*0.18 : parseFloat(pfTypeValue)*0.01*0.18).toFixed(4)) : 0,
    processingfeValueIncludingGST: parseFloat((gst===true ? (pfType==="Flat" ? parseFloat(pfTypeValue)*1.18 : parseFloat(pfTypeValue)*0.01*1.18) : (pfType==="Flat" ? parseFloat(pfTypeValue) : parseFloat(pfTypeValue)*0.01)).toFixed(2)),
    fldgApplicable: fldg===true?true:false,
    fldgPercentage: FLDGpercentage,
    fldgReturnMonth: fldgReturn,
    advanceEmis: advanceEMIValue,
    disbursementMonth1Percentage: disburse?disbursermentPercentage1:100,
    disbursementMonth2Percentage: disburse?disbursermentPercentage2:0,
    disbursementMonth3Percentage: addDisbursement?disbursermentPercentage3:0,
    disbursementMonth4Percentage: addDisbursement2?disbursermentPercentage4:0,
    disbursementMonth1: disburse?disbursementMonth1:0,
    disbursementMonth2: disburse?disbursementMonth2:0,
    disbursementMonth3: addDisbursement?disbursementMonth3:0,
    disbursementMonth4: addDisbursement2?disbursementMonth4:0,
     tenureType:tenureType===false?2:1,
    createdBy: decode?.display_name,
    ...(status === "Standard EMI" && {
      frequency:frequency,
      daysConvention:daysConvention==="Actual Days"?365:360,
      brokenPeriodInterest:brokenPeriodInterest,
      deductBroken :detectBroken,
      addbrokenInterestToFirstemi :addBrokenToFirstEmi,
      ...(decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && {
        otherCharges: otherCharges ? parseFloat(otherCharges) : null,
        documentChargesType: docChargesType === "Flat" ? 1 : docChargesType === "Percentage" ? 2 : null,
        documentChargesValueGst: docChargesValue ? parseFloat((parseFloat(docChargesValue) * 1.18).toFixed(2)) : null,
        stampDuty: stampDutyValue ? parseFloat(stampDutyValue) : null,
      }),
    }),
    }
  
    const createProductUrl=`/products/create`

    dispatch(userActions.createProduct(createProductUrl,productData,user));
   }
  }
  else
  setSnackbar({ open: true, message: 'Some Fields are missing or in wrong Format', severity: 'error' })
}


useEffect(() => {
  if(createProductState==='Successful')
    {
      setSnackbar({ open: true, message: 'Product Added Successfully', severity: 'success' });
      setTimeout(() => { setOpenDialog(false); if(onProductCreated) onProductCreated(); }, 1500);
    }

}, [createProductState])

useEffect(() => {
  if (!openDialog) return;
  // Reset all form fields when the dialog opens
  setProductName(null);
  setIRR(null);
  setIR(Roi || null);
  setDIR(null);
  setSIR(null);
  setPftype(PfType || null);
  setPfTypeValue(PfTypeValue || null);
  setTenure(Tenure || null);
  setInstituteCode(null);
  setInstituteID(null);
  setSelectedInstitutes([]);
  setInstituteIds([]);
  setInstituteList([]);
  setFldg(FlateRate || false);
  setFldgReturn("FLDG");
  setFldgPercentage(null);
  setGST(true);
  setDisbursement(false);
  setDisbursementPercentage1(null);
  setDisbursementPercentage2(null);
  setDisbursementPercentage3(null);
  setDisbursementPercentage4(null);
  setAddDisbursement(false);
  setAddDisbursement2(false);
  setAddDisbursementNext(true);
  setAdvanceEMI(advance || "Advance EMI");
  setStudentShare(null);
  setInstituteShare(null);
  setDisbursementMonth1("Month 1");
  setDisbursementMonth2("Month 2");
  setDisbursementMonth3("Month 3");
  setDisbursementMonth4("Month 4");
  setBrokenPeriodInterest(IncludeBPI !== undefined ? IncludeBPI : false);
  setDetectBroken(DetectBroken !== undefined ? DetectBroken : false);
  setAddBrokenToFirstEmi(AddBrokenToFirstEmi !== undefined ? AddBrokenToFirstEmi : false);
  setFrequency(Frequency || "Monthly");
  setDaysConvention(360);
  setInterestChoice(true);
  setSitChoice(true);
  setDitChoice(true);
  setTenureType(true);
  setLoanType(null);
  setLoanTypeCode("");
  setOtherCharges(null);
  setDocChargesType("Flat");
  setDocChargesValue(null);
  setStampDutyValue(null);
  setPfLimitAmount(null);
  setLoading(false);

  const category = productCategory || (decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "Standard EMI" : null);
  if (category) {
    setStatus(category);
    if (category === "Hybrid") setProductCode("HYD");
    else if (category === "Standard EMI") setProductCode("STD");
    else if (category === "Subvention GST") setProductCode("SVN");
    else if (category === "Subvention Non GST") setProductCode("SNN");
    else if (category === "B2B") setProductCode("BB");
    setTimeout(() => setLoading(true), 1000);
  } else {
    setStatus("Select Category of Product");
  }
}, [openDialog])

const formatTenure = (tenure) => {
  if ( tenure === "Dynamic") return "DY";
  if (!tenure) return "00";
  return String(tenure).padStart(2, "0");
};

const formatAdvanceEMI = (advance) => {
  if (advance === 0) return "0";
  if (!advance) return "0";
  return String(advance);
};

const formatPFValue = (pfValue) => {
  if (!pfValue) return "00";
  return String(pfValue).replace(".", "").slice(0, 2);
};

// Helper function to normalize product code for comparison
const getNormalizedProductCode = (code) => {
  if (code === "HYD" || code === "HY") return "HY";
  if (code === "STD" || code === "ST") return "ST";
  if (code === "SVN" || code === "SV") return "SV";
  if (code === "SNN" || code === "SN") return "SN";
  return code;
};

const autoProductCode = [
  loanTypeCode || "XX",
  productCode || "XXX",
  formatTenure(prodTenure),
  formatAdvanceEMI(advanceEMIValue),
  formatPFValue(pfTypeValue),
].join("");


const [checkedItems, setCheckedItems] = useState({});

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 46, // ⬅️ Increased width here
  height: 24,
  padding: 0,
  display: 'flex',
  '&:active .MuiSwitch-thumb': {
    width: 24,
  },
  '& .MuiSwitch-switchBase': {
    padding: 1,
    '&.Mui-checked': {
      transform: 'translateX(20px)', // ⬅️ Adjusted for new width
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#d32028',
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 24,
    height: 22,
    borderRadius: 12,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 28 / 2,
    opacity: 1,
    backgroundColor: '#ccc',
  },
}));





 return(

  <div>
     {/* <p style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'500', textTransform: 'capitalize',cursor:'pointer',width:'180px',height:'34px',fontFamily:'Inter-Medium',fontSize:'16px',backgroundColor:'#D22129',display:'flex',alignItems:'center',justifyContent:'center',color:'white',borderRadius:'6px'}} onClick={() => popUpForm()}><img src={plus} style={{marginRight:'10px'}}/>Add Product</p>
     */}
      {openDialog && (
      <>
       <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 999,
        }}
      ></div>
      <Modal 
      style={{
      
        top: '0%',
        bottom:'10%',
        backgroundColor: 'white'}} size="xl" className='edit-form ' isOpen={openDialog}>
          
          <div style={{borderTopLeftRadius:'10px',borderTopRightRadius:"10px",display:"flex",flexDirection:'row',justifyContent:"space-between",backgroundColor:"#E9E9E9",alignItems:"center"}}><p className='heading'>Add Product</p>
          <img style={{height:'1.5em',width:'1.5em',cursor:'pointer'}}  className="image1" onClick={()=>setOpenDialog(false)} src={close}/>
          </div>
        
        <ModalBody>

          {/* <div style={{padding:'10px',boxShadow:'0px 0px 1px 1px #D0D0D0',borderRadius:'20px',marginTop:'1em'}}> */}
             <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                  {snackbar.message}
                </Alert>
              </Snackbar>
            <Form>
            <FormGroup>
            <Row>
              <Col >
                <Row>
                <div>
                  <Form>
                  <div style={{display:'block'}}>
                      <div style={{display:'flex',justifyContent: 'space-between',}}>
                      <FormGroup  style={{marginRight:'10px'}}>
              <div style={{paddingLeft:'1em'}}>
                <p style={{fontWeight:'600'}}>Select Product Category</p>
                <Dropdown isOpen={dropDownOpen} toggle={() => handleToggle()}>
                <DropdownToggle caret style={{backgroundColor:'#d32028',border:'none'}}>
                  {status}
                </DropdownToggle>

                <DropdownMenu style={{overflowY:'scroll', gap: '8px', }}>
                <DropdownItem
                    onClick={(e) =>handleLoad(productCategory?productCategory:e)}
                  >
                    Subvention GST
                  </DropdownItem>
                  <DropdownItem onClick={(e) => handleLoad(e)}>
                    Subvention Non GST
                  </DropdownItem>
                  <DropdownItem onClick={(e) => handleLoad(e)}>
                    Standard EMI
                  </DropdownItem>
                  <DropdownItem onClick={(e) => handleLoad(e)}>
                    B2B
                  </DropdownItem>
                  <DropdownItem onClick={(e) =>handleLoad(e)}>
                    Hybrid
                  </DropdownItem>
                
                </DropdownMenu>
              </Dropdown>
            </div>
            </FormGroup>
                      </div>
                      </div>
              
          {!load&&status!=="Select Category of Product"?<div style={{textAlign:'center',fontSize:'2em'}}> Loading...</div>:<div>

                  
              {
                load?<>
                <div key='1' style={{display:'flex'}}>
                  
                <div style={{display:'block',width:'45%',marginLeft:'5%'}}>
                <div style={{marginRight:'10px' , display:'flex',flexDirection: 'row'}}>
                  
                  {/* <FormGroup > */}

                  {(decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c') ? (
                    <div style={{ display: "flex", gap: "1em", alignItems: "flex-start" }}>
                      <Autocomplete
                        multiple
                        size="small"
                        options={(instituteList || []).map(item => ({
                          label: item?.brandName || "Unknown",
                          ...item,
                        }))}
                        value={selectedInstitutes}
                        filterSelectedOptions
                        onChange={(event, newValue) => {
                          setSelectedInstitutes(newValue);
                          const ids = newValue.map(item => item.id);
                          setInstituteIds(ids);
                        }}
                        onInputChange={(event, value) => getInsituteInfo(value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Institute Name"
                            sx={{ minWidth: 280 }}
                          />
                        )}
                      />

                      <Autocomplete
                        size="small"
                        options={loanTypeOptions}
                        getOptionLabel={(option) => option.label}
                        value={loanType}
                        onChange={(e, value) => {
                          setLoanType(value);
                          setLoanTypeCode(value?.code || "");
                          console.log("Loan Type Code:", value?.code);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Loan Type"
                            sx={{ minWidth: 180 }}
                          />
                        )}
                      />
                    </div>
                  ) : (
                    <div style={{flex:'block',overflowX: 'hidden',}} >
                      <Autocomplete
                          sx={{ 
                            "& .MuiPopper-root": { fontFamily: 'Outfit' }
                          }}
                          size="small"
                          options={(instituteList || []).map(item => ({
                            label: item?.brandName || "Unknown",
                            ...item
                          }))}
                          onChange={(event, selectedItem) => handleInstituteDetails(selectedItem)}
                          onInputChange={(event, value) => getInsituteInfo(value)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "Enter Loan Type": "Institute Name"}
                              InputLabelProps={{
                                            // ensures the label behaves properly
                                sx: {
                                  fontFamily: 'Outfit',
                                  bgcolor: "#fff8f4",
                                  fontWeight: 'bold',
                                  borderRadius: '5px',
                                  fontSize: '16px',
                                  lineHeight: '25px',
                                  padding: '2px 8px',
                                  color: '#000'
                                  
                                }
                              }}
                              sx={{
                                minWidth: 350,
                                mb: 2,
                                marginTop:"10px",
                                
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: "#707C8B",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#707C8B",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#d32028",
                                  },
                                 
                                }
                              }}
                            />
                          )}
                        />
                    </div>
                  )}

                  </div>
    
                  <div style={{display:'flex',marginTop:'1.5em'}}>
                  <FormGroup>
              <Autocomplete
                    options={tenureArray}
                    size="small"
                   value={prodTenure === 0 ? "Dynamic" : prodTenure}
                    onChange={(e, value) => {
                      if (value === "Dynamic") {
                        setTenure(0);
                      } else {
                        setTenure(value || '');
                      }
                    }}
                    sx={{
                      minWidth: 225,
                      mb: 2,
                      "& .MuiPopper-root": {
                        fontFamily: 'Outfit',
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Tenure"
                        sx={{
                          
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "#707C8B",
                            },
                            "&:hover fieldset": {
                              borderColor: "#707C8B",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#d32028",
                            },
                           
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontFamily: 'Outfit',
                            bgcolor: "#fff8f4",
                            fontWeight: 'bold',
                            borderRadius: '5px',
                            fontSize: '14px',
                            lineHeight: '20.25px',
                            padding: '2px 8px',
                            color: '#000',
                          },
                        }}
                      />
                    )}
                  />
                  </FormGroup>
                 
                      <FormGroup style={{marginRight:'20px',paddingLeft:'10px'}}>
                      <TextField
                         label="IRR"
                            type="number"
                            size="small"
                            onChange={(e) => setIRR(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            sx={{
                              width: '15em',
                              '& .MuiOutlinedInput-root': {
                                fontFamily: 'Outfit',
                                backgroundColor: '#fff',
                                '& fieldset': {
                                  borderColor: '#707C8B',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#707C8B',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: '#d32028',
                                },
                              },
                            }}
                            InputProps={{
                              sx: {
                                fontFamily: 'Outfit',
                              },
                            }}
                          />
                    
                      </FormGroup>
                  


                  </div>

                  { status==="Standard EMI"?<>
                  <div style={{ display: 'flex', marginRight: '5em', marginTop: '1em' }}>
                  <p style={{ fontWeight: '600', width: '15em' }}> Broken Period Interest Separately </p>
                <  Stack direction="row" spacing={1} alignItems="center">
                <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>No</Typography>
                <AntSwitch
                  checked={brokenPeriodInterest}
                  onChange={(e) => setBrokenPeriodInterest(e.target.checked)}
                  inputProps={{ 'aria-label': 'yes-no switch' }}
                />
                <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Yes</Typography>
              </Stack>
                 </div>
                  <div style={{ display: 'flex', marginRight: '5em', marginTop: '1em' }}>
                            <FormGroup
                style={{
                  marginRight: '5em',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
      <p style={{ fontWeight: '600', width: '15em' }}>Deduct Broken</p>

      <Stack direction="row" spacing={1} alignItems="center">
        <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>No</Typography>
        <AntSwitch
          checked={detectBroken}
          onChange={(e) => setDetectBroken(e.target.checked)}
          inputProps={{ 'aria-label': 'detect broken switch' }}
        />
        <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Yes</Typography>
      </Stack>
           </FormGroup>
                  </div>
                  <div  style={{ display: 'flex', marginRight: '5em', marginTop: '1em' }}>
                  <FormGroup
      style={{
        marginRight: '5em',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <p style={{ fontWeight: '600', width: '15em' }}>Add Broken To FirstEmi</p>

      <Stack direction="row" spacing={1} alignItems="center">
  <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>No</Typography>
  <AntSwitch
    checked={addBrokenToFirstEmi}
    onChange={(e) => setAddBrokenToFirstEmi(e.target.checked)}
    inputProps={{ 'aria-label': 'add broken to first emi' }}
  />
  <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Yes</Typography>
</Stack>
               </FormGroup>
                   </div> </>:""}

                   <div style={{height:'3em',marginTop:"1em",display:'flex'}}>
                    <FormGroup style={{marginRight:'10px' , display:'flex',flexDirection: 'row'}}>
                    <p style={{ fontWeight: '600', width: '8em'}}>FLDG</p>

                    <Stack direction="row" spacing={1} alignItems="center" style={{paddingLeft:'7em'}}  >
                      <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>No</Typography>
                      <AntSwitch
                        checked={fldg}
                        onChange={() => setFldg((prev) => !prev)}
                        inputProps={{ 'aria-label': 'fldg toggle' }}
                      />
                      <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Yes</Typography>
                    </Stack>
                      </FormGroup>
                      
                  </div>
                  {
                    fldg==true?<> <div style={{height:'3em',marginTop:"2em",display:'flex'}}>
                       <TextField
                      label='FLDG %'                   
                      type="number"
                      size="small"
                      onChange={(e) => setFldgPercentage(e.target.value)}
                      sx={{
                        width: '10em',
                        height: '2.5em',
                        fontFamily: 'Outfit',
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: '#fff',
                          fontFamily: 'Outfit',
                          '& fieldset': {
                            borderColor: '#707C8B',
                          },
                          '&:hover fieldset': {
                            borderColor: '#707C8B',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#d32028',
                          },
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: 'Outfit',
                          height: '2.5em',
                        },
                      }}
                    />
                  
                
                  
                  <Autocomplete
                       label='FLDG Return'
                      options={fldgArray}
                      value={fldgReturn}
                      onChange={(e, newValue) => setFldgReturn(newValue || '')}
                      sx={{ width: '15em', marginLeft: '1em' }}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="FLDG Return"
                          sx={{
                            backgroundColor: '#fff',
                            fontFamily: 'Outfit',
                            '& .MuiOutlinedInput-root': {
                              fontFamily: 'Outfit',
                              '& fieldset': {
                                borderColor: '#707C8B',
                              },
                              '&:hover fieldset': {
                                borderColor: '#707C8B',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#d32028',
                              },
                            },
                            '& .MuiInputBase-input': {
                              fontFamily: 'Outfit',
                            },
                          }}
                        />
                      )}
                    />
                  </div></>:null
                  }


{ status==="Hybrid"?<>
                  
                  <div style={{display:'flex', marginTop:'1em'}}>
                  <FormGroup style={{ marginRight: '10px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <p style={{ fontWeight: '600', width: '8em', lineHeight: '1.5em' }}>Discounted Interest Type</p>

                    <Stack direction="row" spacing={1} alignItems="center" style={{paddingLeft:'5em'}}>
                      <Typography sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Reducing</Typography>
                      <AntSwitch
                        checked={DITChoice}
                        onChange={() => setDitChoice((prev) => !prev)}
                        inputProps={{ 'aria-label': 'discounted interest type switch' }}
                      />
                      <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Flat</Typography>
                    </Stack>
                  </FormGroup>
                </div>

                <div style={{display:'flex', marginTop:'1em'}}>
                  <FormGroup style={{ marginRight: '10px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <p style={{ fontWeight: '600', width: '10em', lineHeight: '1.5em' }}>Standard Interest Type(Click to Toggle)</p>

                    <Stack direction="row" spacing={1} alignItems="center" style={{paddingLeft:'3em'}}>
                      <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Reducing</Typography>
                      <AntSwitch
                        checked={SITChoice}
                        onChange={() => setSitChoice((prev) => !prev)}
                        inputProps={{ 'aria-label': 'Standard Interest Type switch' }}
                      />
                      <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Flat</Typography>
                    </Stack>
                  </FormGroup>
                </div>
                
                <div style={{marginTop:"1em",display:'flex'}}>
                 
                </div>
                
                <div style={{marginTop:"0.5em",display:'flex'}}>
                  <FormGroup style={{marginRight:'10px' , display:'flex',flexDirection: 'row'}}>
                  <TextField
                  label='Discounted Interest Rate'
                            type="number"
                            onChange={(e) => setDIR(e.target.value)}
                            size="small"
                            sx={{
                              width: '14em',
                              height: '2.5em',
                              backgroundColor: '#fff',
                              fontFamily: 'Outfit',
                              '& .MuiOutlinedInput-root': {
                                fontFamily: 'Outfit',
                                '& fieldset': {
                                  borderColor: '#707C8B',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#707C8B',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: '#d32028',
                                },
                              },
                              '& .MuiInputBase-input': {
                                height: '2.5em',
                                padding: '0 14px',
                              },
                            }}
                          />
                    </FormGroup>
                    
               
                    <FormGroup>
                <TextField
                      label='Standard Interest Rate'
                      type="number"
                      onChange={(e) => setSIR(e.target.value)}
                      size="small"
                      sx={{
                        width: '14em',
                        height: '2.5em',
                        backgroundColor: '#fff',
                        fontFamily: 'Outfit',
                        '& .MuiOutlinedInput-root': {
                          fontFamily: 'Outfit',
                          '& fieldset': {
                            borderColor: '#707C8B',
                          },
                          '&:hover fieldset': {
                            borderColor: '#707C8B',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#707C8B',
                          },
                        },
                        '& .MuiInputBase-input': {
                          height: '2.5em',
                          padding: '0 14px',
                        },
                      }}
                    />
                    </FormGroup>
                </div>

               
              
              <div style={{display:'block'}}>
                <div style={{height:'3em',marginTop:"2em",display:'flex'}}>
                  <FormGroup style={{marginRight:'10px' , display:'flex',flexDirection: 'row'}}>
                  <TextField
                  label='Institute Share'
                        type="number"
                        onChange={(e) => setInstituteShare(e.target.value)}
                        size="small"
                        sx={{
                          width: '15em',
                          height: '2.5em',
                          backgroundColor: '#fff',
                          fontFamily: 'Outfit',
                          '& .MuiOutlinedInput-root': {
                            fontFamily: 'Outfit',
                            '& fieldset': {
                              borderColor: '#707C8B',
                            },
                            '&:hover fieldset': {
                              borderColor: '#707C8B',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#d32028',
                            },
                          },
                          '& .MuiInputBase-input': {
                            height: '2.5em',
                            padding: '0 14px',
                          },
                        }}
                      />
                    </FormGroup>
               
                  <FormGroup style={{marginRight:'10px' , display:'flex',flexDirection: 'row'}}>
                  <TextField
                  label='Student Share'
                          type="number"
                          onChange={(e) => setStudentShare(e.target.value)}
                          size="small"
                          sx={{
                            width: '15em',
                            backgroundColor: '#fff',
                            fontFamily: 'Outfit',
                            '& .MuiOutlinedInput-root': {
                              fontFamily: 'Outfit',
                              '& fieldset': {
                                borderColor: '#707C8B',
                              },
                              '&:hover fieldset': {
                                borderColor: '#707C8B',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#d32028',
                              },
                            },
                            '& .MuiInputBase-input': {
                              height: '2.5em',
                              padding: '0 14px',
                            },
                          }}
                       />
                    </FormGroup>
                </div>
              </div></>
              
              :
              
              <>
                
                  <div style={{height:'3em', marginTop:'1em', display:'flex'}}>
                  <FormGroup style={{ marginRight: '10px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <p style={{ fontWeight: '600', width: '8em',marginTop:'10px' }}>Interest Type</p>

                    <Stack direction="row" spacing={1} alignItems="center"  style={{paddingLeft:'5em' }}  >
                      <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Reducing</Typography>
                      <AntSwitch
                        checked={interestChoice}
                        onChange={() => setInterestChoice((prev) => !prev)}
                        inputProps={{ 'aria-label': 'interest type toggle' }}
                      />
                      <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Flat</Typography>
                    </Stack>
                </FormGroup>
                </div>
                
                  { status==="Standard EMI" && interestChoice=== true ?<>
                  <div style={{ display: 'flex', marginRight: '5em', marginTop: '1em' }}>
                  <p style={{ fontWeight: '600', width: '12em' }}> Tenure type </p>
                <  Stack direction="row" spacing={2} alignItems="center">
                <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Annual</Typography>
                <AntSwitch
                  checked={tenureType}
                  onChange={(e) => setTenureType(e.target.checked)}
                  inputProps={{ 'aria-label': 'yes-no switch' }}
                />
                <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Per Tenure</Typography>
              </Stack>
                 </div>
                  </> :""}



                <div style={{height:'3em',marginTop:"1.5em"}}>
                  <FormGroup style={{marginRight:'10px' , display:'flex',flexDirection: 'row'}}>
                  <TextField
                      label='Interest Rate'
                      type="number"
                      value={ir}
                      size="small"
                      onChange={(e) => setIR(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                      sx={{
                        width: '15em',
                        height: '2.5em',
                        fontFamily: 'Outfit',
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: '#fff',
                          fontFamily: 'Outfit',
                          '& fieldset': {
                            borderColor: '#707C8B',
                          },
                          '&:hover fieldset': {
                            borderColor: '#707C8B',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#d32028',
                          },
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: 'Outfit',
                          height: '2.5em',
                        },
                      }}
                    />
                    </FormGroup>
                </div>
              </>}

                    
                 
                
                  
                  
                </div>
                <div style={{display:'block',borderLeft:'1px dashed black',width:'45%'}}>
                <div style={{display:'flex',marginLeft:'2em'}}>
                <Autocomplete
                         label='Advance EMI'
                          options={advanceEMIArray}
                          value={advanceEMIValue}
                          onChange={(e, value) => setAdvanceEMI(value)}
                          disableClearable
                          size="small"
                          sx={{ width: '15em', backgroundColor: '#fff' }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select"
                              sx={{
                                fontFamily: 'Outfit',
                                '& .MuiOutlinedInput-root': {
                                  fontFamily: 'Outfit',
                                  '& fieldset': {
                                    borderColor: '#707C8B',
                                  },
                                  '&:hover fieldset': {
                                    borderColor: '#707C8B',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#d32028',
                                  },
                                },
                              }}
                            />
                          )}
                        />
                  </div>
                  <div style={{display:'block',marginLeft:'2em',marginTop:'30px'}}>
                    <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1em', marginTop: '10px' }}>
  {/* Red Code Badge */}
  <span
    style={{
      color: 'white',
      backgroundColor: '#d32028',
      borderRadius: '10px',
      padding: '0px 5px 0px 5px',
      boxShadow: '0px 0px 1px 1px #D0D0D0',
      fontWeight: 'bold',
      marginRight: '1.5em', // space between badge and textfield
      fontFamily: 'Outfit',
    }}
  >
    {(decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c') ? autoProductCode : `${instituteCode}-${productCode}`}
  </span>

  {/* Product Name Input */}
  {(decode?.clientId === '' || decode?.clientId === 'd428c3d0-b5c7-4e9c-857b-e76c1cb8248c')?null:(
   <TextField
    label="Product Name"
    variant="outlined"
    onChange={(e) => setProductName(e.target.value)}
    size="small"
    sx={{
      width: '10em',
      fontFamily: 'Outfit',
      '& .MuiOutlinedInput-root': {
        fontFamily: 'Outfit',
        '& fieldset': {
          borderColor: '#707C8B',
        },
        '&:hover fieldset': {
          borderColor: '#707C8B',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#d32028',
        },
      },
      '& .MuiInputLabel-root': {
        fontFamily: 'Outfit',
        fontWeight: 'bold',
        fontSize: '14px',
      },
    }}
  /> 
  )}
  
</div>

                      </FormGroup>
                     
                  </div>
                 
                  <div style={{display:'flex', marginTop:'2em'}}>
                  <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>

                  <Autocomplete
                                  label ='PF Type'
                                  options={["Flat", "Percentage", "Varied"]}
                                  value={pfType}
                                  onChange={(e, value) => setPftype(value)}
                                  disableClearable
                                  size="small"
                                  sx={{
                                    width: '14em',
                                    backgroundColor: '#fff',
                                    marginLeft: '2em',
                                    fontFamily: 'Outfit',
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                    label ='PF Type'
                                      {...params}
                                      placeholder="Select"
                                      sx={{
                                        fontFamily: 'Outfit',
                                        '& .MuiOutlinedInput-root': {
                                          fontFamily: 'Outfit',
                                          '& fieldset': {
                                            borderColor: '#707C8B',
                                          },
                                          '&:hover fieldset': {
                                            borderColor: '#707C8B',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: '#d32028',
                                          },
                                        },
                                      }}
                                    />
                                  )}
                                /> </FormGroup>
                        </div>
                          <div style={{display:'flex',marginLeft:'2em', marginTop : '1em'}}>
                   {pfType==="Varied"?<div style={{display:'flex'}}>
                     <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
                             <TextField
                             label='Limit Amount'
                                    type="number"
                                    onChange={(e) => setPfLimitAmount(e.target.value)}
                                     onWheel={(e) => e.target.blur()}
                                    size="small"
                                    sx={{
                                      width: '15em',
                                      fontFamily: 'Outfit',
                                      '& .MuiOutlinedInput-root': {
                                        fontFamily: 'Outfit',
                                        '& fieldset': {
                                          borderColor: '#707C8B',
                                        },
                                        '&:hover fieldset': {
                                          borderColor: '#707C8B',
                                        },
                                        '&.Mui-focused fieldset': {
                                          borderColor: '#d32028',
                                        },
                                      },
                                    }}
                                  />
                            </FormGroup>
                        </div>:null}
                
                    <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
  

                                    <TextField
                                      label='PF Value'
                                      type="number"
                                      value={pfTypeValue}
                                      onChange={(e) => setPfTypeValue(e.target.value)}
                                      onWheel={(e) => e.target.blur()}
                                      size="small"
                                      sx={{
                                        width: '14em',
                                        fontFamily: 'Outfit',
                                        '& .MuiOutlinedInput-root': {
                                          fontFamily: 'Outfit',
                                          '& fieldset': {
                                            borderColor: '#707C8B',
                                          },
                                          '&:hover fieldset': {
                                            borderColor: '#707C8B',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: '#d32028',
                                          },
                                        },
                                      }}
                                    />
                      </FormGroup>
                  </div>
                  <div style={{display:'flex',marginLeft:'2em', marginTop:'1em'}}>
                    <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
                    <p style={{ fontWeight: '600', width: '8em',}}>GST</p>

                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>No</Typography>
                    <AntSwitch
                      checked={gst}
                      onChange={() => setGST((prev) => !prev)}
                      inputProps={{ 'aria-label': 'GST switch' }}
                    />
                    <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Yes</Typography>
                  </Stack>
                     
                     
                      </FormGroup>
                  </div>
                  <div style={{display:'flex',marginLeft:'2em', marginTop:'1em'}}>
                    <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
                    <TextField
                       label='PF + GST'
                            type="number"
                            value={
                              gst && pfTypeValue
                                ? (parseFloat(pfTypeValue) + parseFloat(pfTypeValue) * 0.18).toFixed(2)
                                : pfTypeValue
                            }
                            disabled
                            size="small"
                            InputLabelProps={{
                              shrink: true,
                              sx: {
                                fontWeight: 'bold',
                                fontFamily: 'Outfit',
                                fontSize: '14px',
                              },
                            }}
                            sx={{
                              width: '15em',
                              marginBottom: '1em',
                              fontFamily: 'Outfit',
                              '& .MuiOutlinedInput-root': {
                                fontFamily: 'Outfit',
                                backgroundColor: '#f5f5f5',
                                '& fieldset': {
                                  borderColor: '#707C8B',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#707C8B',
                                },
                              },
                            }}
                          />
                      </FormGroup>
                  </div>

                  {status === "Standard EMI" && decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (
                    <div style={{display:'flex',marginLeft:'2em', marginTop:'0.5em'}}>
                      <FormGroup style={{marginRight:'1em', display:'flex', flexDirection:'row'}}>
                        <TextField
                          label='Admin Charges + GST'
                          type="number"
                          value={otherCharges ?? ''}
                          onChange={(e) => setOtherCharges(e.target.value)}
                          onWheel={(e) => e.target.blur()}
                          size="small"
                          sx={{
                            width: '15em',
                            fontFamily: 'Outfit',
                            '& .MuiOutlinedInput-root': {
                              fontFamily: 'Outfit',
                              backgroundColor: '#fff',
                              '& fieldset': { borderColor: '#707C8B' },
                              '&:hover fieldset': { borderColor: '#707C8B' },
                              '&.Mui-focused fieldset': { borderColor: '#d32028' },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontFamily: 'Outfit',
                              fontWeight: 'bold',
                              fontSize: '14px',
                            },
                          }}
                        />
                      </FormGroup>
                    </div>
                  )}

                  {status === "Standard EMI" && decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (
                    <>
                      <div style={{display:'flex', marginLeft:'2em', marginTop:'1em'}}>
                        <FormGroup style={{marginRight:'1em', display:'flex', flexDirection:'row'}}>
                          <Autocomplete
                            options={["Flat", "Percentage"]}
                            value={docChargesType}
                            onChange={(e, value) => setDocChargesType(value)}
                            disableClearable
                            size="small"
                            sx={{ width: '14em', backgroundColor: '#fff', fontFamily: 'Outfit' }}
                            renderInput={(params) => (
                              <TextField
                                label='Document Charges Type'
                                {...params}
                                placeholder="Select"
                                InputLabelProps={{ sx: { fontFamily: 'Outfit', fontWeight: '600', fontSize: '14px' } }}
                                sx={{
                                  fontFamily: 'Outfit',
                                  '& .MuiOutlinedInput-root': {
                                    fontFamily: 'Outfit',
                                    '& fieldset': { borderColor: '#707C8B' },
                                    '&:hover fieldset': { borderColor: '#707C8B' },
                                    '&.Mui-focused fieldset': { borderColor: '#d32028' },
                                  },
                                }}
                              />
                            )}
                          />
                        </FormGroup>
                      </div>
                      <div style={{display:'flex', marginLeft:'2em', marginTop:'1em'}}>
                        <FormGroup style={{marginRight:'1em', display:'flex', flexDirection:'row'}}>
                          <TextField
                            label='Document Charges Value'
                            type="number"
                            value={docChargesValue ?? ''}
                            onChange={(e) => setDocChargesValue(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            size="small"
                            sx={{
                              width: '15em',
                              fontFamily: 'Outfit',
                              '& .MuiOutlinedInput-root': {
                                fontFamily: 'Outfit',
                                backgroundColor: '#fff',
                                '& fieldset': { borderColor: '#707C8B' },
                                '&:hover fieldset': { borderColor: '#707C8B' },
                                '&.Mui-focused fieldset': { borderColor: '#d32028' },
                              },
                            }}
                            InputLabelProps={{ sx: { fontFamily: 'Outfit', fontWeight: 'bold', fontSize: '14px' } }}
                          />
                        </FormGroup>
                      </div>
                      <div style={{display:'flex', marginLeft:'2em', marginTop:'1em'}}>
                        <FormGroup style={{marginRight:'1em', display:'flex', flexDirection:'row'}}>
                          <TextField
                            label='Document Charges + GST'
                            type="number"
                            value={docChargesValue ? (parseFloat(docChargesValue) * 1.18).toFixed(2) : ''}
                            disabled
                            size="small"
                            InputLabelProps={{ shrink: true, sx: { fontWeight: 'bold', fontFamily: 'Outfit', fontSize: '14px' } }}
                            sx={{
                              width: '15em',
                              marginBottom: '1em',
                              fontFamily: 'Outfit',
                              '& .MuiOutlinedInput-root': {
                                fontFamily: 'Outfit',
                                backgroundColor: '#f5f5f5',
                                '& fieldset': { borderColor: '#707C8B' },
                                '&:hover fieldset': { borderColor: '#707C8B' },
                              },
                            }}
                          />
                        </FormGroup>
                      </div>
                      <div style={{display:'flex', marginLeft:'2em', marginTop:'1em'}}>
                        <FormGroup style={{marginRight:'1em', display:'flex', flexDirection:'row'}}>
                          <TextField
                            label='Stamp Duty'
                            type="number"
                            value={stampDutyValue ?? ''}
                            onChange={(e) => setStampDutyValue(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            size="small"
                            sx={{
                              width: '15em',
                              fontFamily: 'Outfit',
                              '& .MuiOutlinedInput-root': {
                                fontFamily: 'Outfit',
                                backgroundColor: '#fff',
                                '& fieldset': { borderColor: '#707C8B' },
                                '&:hover fieldset': { borderColor: '#707C8B' },
                                '&.Mui-focused fieldset': { borderColor: '#d32028' },
                              },
                            }}
                            InputLabelProps={{ sx: { fontFamily: 'Outfit', fontWeight: 'bold', fontSize: '14px' } }}
                          />
                        </FormGroup>
                      </div>
                    </>
                  )}

                  { status==="Standard EMI"?<>
                  <div style={{display:'flex',marginLeft:'2em', marginTop:'1em'}}>
                    <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
                      <FormControl component="fieldset">
                           <FormLabel component="legend">Frequency</FormLabel>
                           <RadioGroup
                             row
                             value={frequency}
                             onChange={(e) => setFrequency(e.target.value)}
                           >
                             {['daily', 'Monthly', 'quarterly', 'bi-annually', 'annually'].map(opt => (
                               <FormControlLabel
                                 key={opt}
                                 value={opt}
                                 control={<Radio />}
                                 label={opt.charAt(0).toUpperCase() + opt.slice(1)}
                                 disabled={opt !== 'Monthly'}
                               />
                             ))}
                           </RadioGroup>
                         </FormControl>
                    </FormGroup>
                  </div>

                  <div style={{display:'flex',marginLeft:'2em', marginTop:'1em'}}>
                    <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
                      
                        <FormControl component="fieldset">
                                    <FormLabel component="legend">Days Convention</FormLabel>
                                      <RadioGroup
                                        row
                                        value={daysConvention.toString()}  // Ensure the current value is string
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          setDaysConvention(value === "" ? "" : Number(value)); 
                                        }}
                                      >
                                        <FormControlLabel value="360" control={<Radio />} label="360" />
                                        <FormControlLabel value="365" control={<Radio />} label="365" />
                                      </RadioGroup>
                                  </FormControl>

                      </FormGroup>
                      </div> </>:""}

                  <div style={{display:'block'}}>
                  <div style={{display:'flex',marginLeft:'1em', marginTop : '1em'}}>
                  <FormGroup style={{ marginRight: '1em', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <p style={{ fontWeight: '600', width: '8em', lineHeight: '1.5em' }}>Disbursement in Tranches</p>

      <Stack direction="row" spacing={1} alignItems="center" style={{paddingLeft:'2em'}}>
        <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>No</Typography>
        <AntSwitch
          checked={disburse}
          onChange={() => setDisbursement(prev => !prev)}
          inputProps={{ 'aria-label': 'Disbursement toggle' }}
        />
        <Typography  sx={{fontFamily: "Outfit", fontWeight: "bold"}}>Yes</Typography>
      </Stack>
    </FormGroup>
                  </div>
                      {
                        disburse===true?<>
                      <div style={{display:'flex',marginLeft:'3em', marginTop:'3em'}}>
                        <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
                      <p style={{fontWeight:'600',width:'8em',}}>Disbursement 1</p>
                      <Dropdown style={{marginBottom:'1em',marginLeft:'2em'}}  isOpen={disbursementMonth1DropDownOpen} toggle={() => handleDisbursementMonth1Toggle()}>
                        <DropdownToggle caret style={{backgroundColor:'#d32028',border:'none'}}>
                          {disbursementMonth1}
                        </DropdownToggle>
                              <DropdownMenu style={{height:"12em",overflowY: 'scroll',}}>
                              {disbursementMonth1Array.map((item)=>{return(<><DropdownItem onClick={(e)=>setDisbursementMonth1(e.target.innerText)}>
                                {item}
                              </DropdownItem></>)})}
                              
                              </DropdownMenu>
                      </Dropdown>
                      <Input type="number"  onChange={(e)=>setDisbursementPercentage1(e.target.value)} placeholder="% Percentage"  style={{height:'2.5em',width:'7.5em',marginLeft:'1em',}}/>
                      </FormGroup>
                      
                  </div>
                  <div style={{display:'flex',marginLeft:'3em', marginTop:'3em'}}>
                    <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
                      <p style={{fontWeight:'600',width:'8.2em',}}>Disbursement 2</p>
                      <Dropdown style={{marginBottom:'1em',marginLeft:'2em'}}  isOpen={disbursementMonth2DropDownOpen} toggle={() => handleDisbursementMonth2Toggle()}>
                        <DropdownToggle caret style={{backgroundColor:'#d32028',border:'none'}}>
                          {disbursementMonth2}
                        </DropdownToggle>
                              <DropdownMenu style={{height:"12em",overflowY: 'scroll',}}>
                              {disbursementMonth2Array.map((item)=>{return(<><DropdownItem onClick={(e)=>setDisbursementMonth2(e.target.innerText)}>
                                {item}
                              </DropdownItem></>)})}
                              
                              </DropdownMenu>
                      </Dropdown>
                      <Input type="number"  onChange={(e)=>setDisbursementPercentage2(e.target.value)} placeholder="% Percentage"  style={{height:'2.5em',width:'7.5em',marginLeft:'1em',}}/>
                      </FormGroup>
                    {  !addDisbursement?<div onClick={()=>setAddDisbursement(true)} ><span style={{ }}><img style={{width:'1.5em',height:'1.5em',marginLeft:'10px'}} alt="" src={increase}/></span>
                      
                  </div>:null}
                  
                  
                  </div>{
                      addDisbursement?
                      <div style={{display:'flex',marginLeft:'3em', marginTop:'3em'}}>
                        <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
                      <p style={{fontWeight:'600',width:'8.2em',}}>Disbursement 3</p>
                      <Dropdown
                  isOpen={formDropDownOpen}
                  toggle={handleFormToggle}
                  style={{ marginBottom: '1em', marginLeft: '3em' }}
                >
                  <DropdownToggle caret style={{ backgroundColor: '#d32028', border: 'none' }}>
                    {prodTenure}
                  </DropdownToggle>

                  <DropdownMenu style={{ height: '12em', overflowY: 'scroll' }}>
                    {tenureArray.map((item, index) => (
                      <DropdownItem key={index} onClick={() => setTenure(item)}>
                        {item}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
                      <Input type="number"  onChange={(e)=>setDisbursementPercentage3(e.target.value)} placeholder="% Percentage"  style={{height:'2.5em',width:'7.5em',marginLeft:'1em',}}/>
                      </FormGroup>
                      <div  style={{display:'flex'}} ><span onClick={()=>setAddDisbursement(false)} style={{marginLeft:'10px'}}><img style={{width:'1.5em',height:'1.5em',marginLeft:'10px'}} src={minus} alt=""/></span>
                      {  addDisbursementNext?
                      <div>
                        <span  onClick={()=>handleAddDisbursement()} style={{  }}><img style={{width:'1.5em',height:'1.5em',marginLeft:'10px'}} src={increase} alt=""/></span>  
                  </div>:null
                  }
                  
                      </div>
                      
                    </div>
                    
                    :null
                    

                    }
                      {!addDisbursementNext?<div style={{display:'flex',marginLeft:'3em', marginTop:'3em'}}>
                        <FormGroup style={{marginRight:'1em' , display:'flex',flexDirection: 'row'}}>
                      <p style={{fontWeight:'600',width:'8.3em',}}>Disbursement 4</p>
                      <Dropdown style={{marginBottom:'1em',marginLeft:'2em'}}  isOpen={disbursementMonth4DropDownOpen} toggle={() => handleDisbursementMonth4Toggle()}>
                        <DropdownToggle caret style={{backgroundColor:'#d32028',border:'none'}}>
                          {disbursementMonth4}
                        </DropdownToggle>
                              <DropdownMenu style={{height:"12em",overflowY: 'scroll',}}>
                              {disbursementMonth4Array.map((item)=>{return(<><DropdownItem onClick={(e)=>setDisbursementMonth4(e.target.innerText)}>
                                {item}
                              </DropdownItem></>)})}
                              
                              </DropdownMenu>
                      </Dropdown>
                      <Input type="number" onChange={(e)=>setDisbursementPercentage4(e.target.value)} placeholder="% Percentage"  style={{height:'2.5em',width:'7.5em',marginLeft:'1em',}}/>
                      </FormGroup>
                    {  !addDisbursementNext?<div onClick={()=>handleAddDisbursement2()} ><span style={{  }}><img style={{width:'1.5em',height:'1.5em',marginLeft:'10px'}} src={minus} alt=""/></span>
                      
                  </div>:null}
                  
                  
                  </div>:null}</>:null
                      
                }
                  </div>
                  </div>
              </div>
                </>:null
              }
            
            </div>
}
              <div style={{display:'flex',marginTop:'1em',justifyContent: 'space-around',}}>
                
                <Button
                  onClick={() => {
                    handleCreateProduct()
                  }}
                  style={{backgroundColor:'#d32028',border:'none'}}
                
                >
                  Submit
                </Button>
              
              </div>
              </Form>
              </div>
              </Row>
              </Col>
              </Row>
              </FormGroup>
              </Form>
        </ModalBody>
        </Modal>
        </>
        
      )}
      </div>

  );
 }